import React from "react";

export class RouteErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) {
    try { console.error("[FieldRadar] render crash", error, info?.componentStack); } catch {}
  }
  componentDidUpdate(prev) {
    if (this.state.error && prev.location !== this.props.location) this.setState({ error: null });
  }
  render() {
    if (!this.state.error) return this.props.children;
    const msg = String(this.state.error?.message || this.state.error);
    return (
      <div className="min-h-screen bg-[#f4f4f5] flex items-center justify-center p-6" data-testid="route-error-boundary">
        <div className="max-w-lg w-full bg-white border-2 border-[#0B1C2D] shadow-[8px_8px_0px_#0B1C2D] p-6">
          <div className="text-[10px] font-black uppercase tracking-widest text-rose-600">This page hit an error</div>
          <h1 className="font-display font-black text-2xl mt-1 text-[#0B1C2D]">Something broke while drawing this screen</h1>
          <p className="text-sm text-slate-600 mt-2">Your data is safe. Send this message to support so it can be fixed:</p>
          <pre className="mt-3 p-3 bg-slate-900 text-rose-200 text-[11px] whitespace-pre-wrap break-all max-h-40 overflow-auto" data-testid="route-error-message">{msg}</pre>
          <div className="mt-4 flex gap-2 flex-wrap">
            <button onClick={() => window.location.reload()} data-testid="route-error-reload"
              className="px-4 py-2 bg-[#0B1C2D] text-white text-xs font-black uppercase tracking-widest">Reload</button>
            <a href="/admin" data-testid="route-error-home"
              className="px-4 py-2 border-2 border-[#0B1C2D] text-xs font-black uppercase tracking-widest">Back to dashboard</a>
          </div>
        </div>
      </div>
    );
  }
}
